import React, { useRef, useEffect, useState } from "react";

const withHelpText =
  Component =>
  ({ helpText, ...otherProps }) => {
    const compRef = useRef();
    const [msgStyles, setMsgStyles] = useState({});

    if (helpText) {
      // check resposive logic only if we have to show helpText
      const [runEffect, setRunEffect] = useState(true);

      const setStyles = () => {
        if (window.innerWidth > 768 && compRef.current) {
          setMsgStyles({
            position: "absolute",
            left: 0,
            width: compRef.current.offsetWidth,
            height: compRef.current.offsetHeight,
            top: compRef.current.offsetHeight - 60,
          });
        } else {
          setMsgStyles({
            position: "relative",
          });
        }
      };

      useEffect(() => {
        if (runEffect) {
          // to have an effect of componentDidMount run effect only once
          setStyles(); // to set styles on intial load
          window.addEventListener("resize", setStyles); // enable only window resize is needed
          setRunEffect(false);
        }
      }, [helpText, runEffect, setStyles]);
    }

    return (
      <div style={{ position: "relative" }} ref={compRef}>
        <Component {...otherProps} />
        {helpText && (
          <div style={msgStyles}>
            <p className="input-label">{helpText}</p>
          </div>
        )}
      </div>
    );
  };

export default withHelpText;
